export default class Search {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.$form = $wrapper.querySelector('[data-search-form]');
        this.$openSearch = this.$wrapper.querySelector('[data-header-open-search]');
        this.$searchField = this.$wrapper.querySelector('[data-header-search]');
        this.$cloneRefenrece = this.$wrapper.querySelector('[data-search-clone-reference]');
        this.$searchContainer = this.$wrapper.querySelector('[data-search-container]');
        this.$closeSearch = this.$wrapper.querySelectorAll('[data-header-close-search]');
        this.$searchPanel = document.querySelector('[data-search-panel]');
        this.$cloneSearch = document.querySelectorAll('[data-clone-search]');
        this.$searchAnimate = [];

        this.openSearch = this.openSearch.bind(this);
        this.closeSearch = this.closeSearch.bind(this);
        this.cloneSearch = this.cloneSearch.bind(this);
        // this.hoverSearch = this.hoverSearch.bind(this);
        // this.stopHoverSearch = this.stopHoverSearch.bind(this);

        this.$cloneSearch?.forEach( $field => $field.addEventListener('focus', this.cloneSearch));
        this.$searchField?.addEventListener('focus', this.openSearch);
        // this.$searchField.addEventListener('mouseenter', this.hoverSearch);
        // this.$openSearch .addEventListener('mouseenter', this.hoverSearch);
        // this.$openSearch .addEventListener('mouseleave', this.stopHoverSearch);
        // this.$searchField.addEventListener('mouseleave', this.stopHoverSearch);
        this.$openSearch?.addEventListener('click', this.openSearch);
        this.$closeSearch.forEach( $button => $button.addEventListener('click', this.closeSearch));

        if(window.location.hash.startsWith("#search")) {
            // get the search params from the hash
            const searchParams = new URLSearchParams(window.location.hash.substr(window.location.hash.indexOf('?'), window.location.hash.length));
            this.$searchField.value = searchParams.get('q');
            this.openSearch();
        }

        this.$form?.addEventListener('submit', (e) => {
            e.preventDefault();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === "Escape") {
                this.closeSearch(e);
            }
        });
    }
    //
    // hoverSearch(e) {
    //     this.$wrapper.classList.add('header--search-hover');
    //     this.$searchField.classList.add('header__search-control--hover');
    // }
    //
    // stopHoverSearch() {
    //     this.$wrapper.classList.remove('header--search-hover');
    //     this.$searchField.classList.remove('header__search-control--hover');
    // }

    openSearch(e) {
        if(e) {
            e.preventDefault();
        }

        this.$wrapper.classList.add('header--search');
        this.$searchField.classList.remove('form__control--bg');
        this.$searchPanel.classList.add('search-panel--show');

        document.querySelector('body').classList.add('no-scroll');

        const event = new CustomEvent('toggle', {
            detail: {
                opened: true
            }
        })

        this.$searchPanel.dispatchEvent(event);
    }

    closeSearch(e) {
        e.preventDefault();
        this.$wrapper.classList.remove('header--search');
        this.$searchField.classList.add('form__control--bg');
        this.$searchPanel.classList.remove('search-panel--show');
        document.querySelector('body').classList.remove('no-scroll');

        // if the search was triggerd by a cloneSearch call we remove the cloned field
        this.$wrapper.querySelectorAll('[data-clone-search]').forEach( $field => $field.remove());
        // and display the original search field again
        this.$searchField.classList.remove('header__search-control--hidden');
        this.$searchField.value = '';
        this.$searchField.blur();

        const event = new CustomEvent('toggle', {
            detail: {
                opened: false
            }
        })
        this.$searchPanel.dispatchEvent(event);
    }

    cloneSearch(e) {
        const $container = this.$cloneRefenrece;
        const rect = e.target.getBoundingClientRect();

        //first we clone the element and set the starting state
        const $el = e.target.cloneNode();
        $el.classList.remove('form__control--big');
        $el.classList.remove('form__control--no-border');
        $el.classList.remove('search-block__input');
        $el.classList.add('form__control--focus-font-size');
        $el.classList.add('form__control--text-small');

        $el.style.position = 'fixed';
        $el.style.transition = 'all .3s ease-out';
        $el.style.zIndex = "20";
        $el.style.top = rect.top + "px";
        $el.style.left = rect.left + "px";
        $el.style.width = rect.width + "px";
        this.openSearch(e);

        // apend the element to the search box
        this.$searchContainer.append($el);
        // hide the default search field
        this.$searchField.classList.add('header__search-control--hidden');

        // get the reference element style
        // this is the style we want the element to transform to
        const containerRect = $container.getBoundingClientRect();
        // add the style
        $el.style.top = containerRect.top + "px";
        $el.style.left = containerRect.left + "px";
        $el.style.width = containerRect.width + "px";
        $el.focus();

        // after the animation remove the fixed styling so this element is responsive
        setTimeout( () => {
            $el.style.transition = '';
            $el.style.position = '';
            $el.style.zIndex = "";
            $el.style.top = '';
            $el.style.left = '';
            $el.style.width = '';
        }, 300)
    }
}